import { Component, uiElement, uiEvent, uiElements } from "@kluntje/core";
import { addClass, removeClass } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE } from "Constants/cssClasses";
import { CookieSettingsGroup } from "Components/wec-m-cookie-settings-group/wec-m-cookie-settings-group";
import CookieService from "Services/CookieService";
import FocusService from "Services/FocusService";
import ScrollLockService from "Services/ScrollLockService";

export class CookieSettingsOverlay extends Component {
  @uiElement(".wec-m-cookie-settings-overlay__btn--save")
  saveBtn: HTMLButtonElement;

  @uiElement(".wec-m-cookie-settings-overlay__btn--save-accept")
  acceptAndSaveBtn: HTMLButtonElement;

  @uiElements(".wec-m-cookie-settings-group")
  consentGroups: Array<CookieSettingsGroup>;

  open() {
    addClass(this, ACTIVE);
    FocusService.trapFocusIn(this);
    ScrollLockService.lockPage();
  }

  close() {
    removeClass(this, ACTIVE);
    FocusService.unTrapFocusIn(this);
    ScrollLockService.unlockPage();
  }

  @uiEvent("saveBtn", "click")
  handleSaveBtnClick() {
    CookieService.allowCookies();
    this.saveAllCategories();
    this.close();
  }

  @uiEvent("acceptAndSaveBtn", "click")
  handleAcceptAndSaveBtnClick() {
    CookieService.allowCookies();
    this.acceptAllCategories();
    this.close();
  }

  acceptAllCategories() {
    this.saveAllCategories(true);
  }

  saveAllCategories(newConsentState?: boolean) {
    this.consentGroups.forEach(consentGroup => consentGroup.saveAll(newConsentState));
  }
}

customElements.define("wec-m-cookie-settings-overlay", CookieSettingsOverlay);
